/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { TopCustomersByEarliestContactDto } from '../dto';

export const TopCustomersByEarliestContactMapper = entity<TopCustomersByEarliestContactDto>({});
